<form [formGroup]="formGroup">
  <p-dropdown
    [options]="chartOptions"
    formControlName="chartType"
    dataKey="graphId"
    optionLabel="label"
  ></p-dropdown>
</form>
<ng-container>
  <p-chart #chart [type]="chartType" [data]="data"></p-chart>
</ng-container>
